import { AppBar, Box, Toolbar, makeStyles } from "@material-ui/core"
import clsx from "clsx"
import PropTypes from "prop-types"
import React from "react"

const useStyles = makeStyles(theme => ({
  root: {
    background: "white",
    [theme.breakpoints.up("md")]: {
      paddingLeft: 256,
    },
  },
  toolbar: {
    minHeight: 64,
  },
}))

const AppTopBar = ({ start, brand, end, className, ...rest }) => {
  const classes = useStyles()

  return (
    <AppBar className={clsx(classes.root, className)} color="inherit" {...rest}>
      <Toolbar className={classes.toolbar}>
        {start}
        {brand}
        <Box ml={2} flexGrow={1} />
        {end}
      </Toolbar>
    </AppBar>
  )
}

AppTopBar.propTypes = {
  brand: PropTypes.node,
  className: PropTypes.string,
  end: PropTypes.node,
  start: PropTypes.node,
}

AppTopBar.defaultProps = {
  brand: null,
  className: "",
  end: null,
  start: null,
}

export default AppTopBar
